export default __webpack_public_path__ + "static/brazing-tablet-d0e78190b2b5b7ecccac0b3ee9a0eeb4.webp";